import { render, staticRenderFns } from "./SignupWithAccessCode.vue?vue&type=template&id=064f9f16&scoped=true"
import script from "./SignupWithAccessCode.vue?vue&type=script&lang=ts"
export * from "./SignupWithAccessCode.vue?vue&type=script&lang=ts"
import style0 from "./SignupWithAccessCode.vue?vue&type=style&index=0&id=064f9f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f9f16",
  null
  
)

export default component.exports